import { Navigate } from 'react-router';
import { useAuthContext } from '../../contexts/authContext';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

const NotAuthenticatedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, role } = useAuthContext();

  if (isAuthenticated) {
    return role === 'ADMIN' ? (
      <Navigate to="/admin" replace />
    ) : (
      <Navigate to="/projects" replace />
    );
  }

  return <>{children}</>;
};

export default NotAuthenticatedRoute;
